export const COMPANY_CONFIG = {
    name: "CASA SCHETTINI",
    shortName: "CASA SCHETTINI",
    logoPath: "/images/logo-schettini.png", 
    colors: {
        primary: "#D32F2F",
        secondary: "#FFFFFF",
    },
    contactEmail: "soporte@schettini.com",
    ticketSystem: {
        autoAssignDepartment: true,
        defaultSubject: "Solicitud de Asistencia",
    }
};